import React, { useState, useEffect } from "react";
import { getI18n } from "react-i18next";
import { useForm } from "react-hook-form";
import { API, STATIC } from "../../env";
import swal from "sweetalert";

function ContactPage() {
  const _ = getI18n();
  const { register, handleSubmit, errors, reset, getValues } = useForm();
  const [data, setData] = useState({});
  const [imgData, setImgData] = useState(null);
  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  useEffect(() => {
    const fetchData = () => {
      fetch(API.content.load, {
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          'x-site-id': JSON.parse(localStorage.getItem('currentSite'))._id,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: "CONTACT",
        }),
      })
        .then((res) => res.json())
        .then((response) => {
          console.log(response);
          setData(response);
        })
        .catch((e) => {});
    };
    fetchData();
  }, []);
  const onSubmit = (dataa) => {
    console.log(dataa);
    const formData = new FormData();
    formData.append("name", "CONTACT");
    if (getValues("subHeaderImage").length > 0) {
      formData.append("files", dataa.subHeaderImage[0], "subHeaderImage");
    }
    if (getValues("subHeaderImage").length === 0) {
      if (data.subHeaderImage !== "") {
        dataa.subHeaderImage = data.subHeaderImage;
      } else {
        dataa.subHeaderImage = "";
      }
    }
    formData.append("content", JSON.stringify(dataa));

    fetch(API.content.update, {
      method: "POST",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
        'x-site-id': JSON.parse(localStorage.getItem('currentSite'))._id,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal(_.t("ERROR"), response.message, "error");
        }
        return swal(_.t("SUCCESS"), _.t("DATA_UPDATED"), "success");
      })
      .catch((e) => swal(_.t("ERROR"), _.t("SERVER_ERR"), "error"));
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("TITLE")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("TITLE_PH")}
                      ref={register({ required: true })}
                      name="title"
                      defaultValue={data.title ? data.title : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  {imgData !== null ? (
                    <img
                      style={{
                        width: "600px",
                        height: "300px",
                        textAlign: "center",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      src={imgData}
                    />
                  ) : (
                    data.subHeaderImage && (
                      <img
                        style={{
                          width: "600px",
                          height: "300px",
                          textAlign: "center",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        src={STATIC.ROUTE(data.subHeaderImage)}
                      />
                    )
                  )}
                </div>
                <div className="form-group row">
                  <label for="name" className="col-sm-2 col-form-label">
                    {_.t("SUB_HEADER_IMAGE")}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="file"
                      className="filestyle"
                      ref={register}
                      name="subHeaderImage"
                      onChange={onChangePicture}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>{`${_.t("BOX_1_TITLE")}`}*</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`${_.t("BOX_1_TITLE_PH")}`}
                      ref={register({ required: true })}
                      name="box1Title"
                      defaultValue={data.box1Title ? data.box1Title : ""}
                    />
                    {errors.step1Title && (
                      <span className="text-danger">
                        {`${_.t("BOX_1_TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label>{`${_.t("BOX_2_TITLE")}`}*</label>
                    <input
                      className="form-control"
                      placeholder={`${_.t("BOX_2_TITLE_PH")}`}
                      ref={register({ required: true })}
                      name="box2Title"
                      rows="3"
                      defaultValue={data.box2Title ? data.box2Title : ""}
                    />
                    {errors.step1Content && (
                      <span className="text-danger">
                        {`${_.t("BOX_2_TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("CONTACT_FORM_TITLE")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("CONTACT_FORM_TITLE_PH")}
                      ref={register({ required: true })}
                      name="formTitle"
                      defaultValue={data.formTitle ? data.formTitle : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("CONTACT_FORM_TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("CONTACT_FORM_DESCRIPTION")}*
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className="form-control"
                      type="text"
                      placeholder={_.t("CONTACT_FORM_DESCRIPTION_PH")}
                      ref={register({ required: true })}
                      name="formDescription"
                      defaultValue={
                        data.formDescription ? data.formDescription : ""
                      }
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("CONTACT_FORM_DESCRIPTION")} ${_.t(
                          "RQUIRED_FIELD"
                        )}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("CONTENT_BUTTON")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("CONTENT_BUTTON_PH")}
                      ref={register({ required: true })}
                      name="contentButton"
                      defaultValue={
                        data.contentButton ? data.contentButton : ""
                      }
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("CONTENT_BUTTON")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("BUTTON_MAPS")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("BUTTON_MAPS_PH")}
                      ref={register({ required: true })}
                      name="buttonmaps"
                      defaultValue={data.buttonmaps ? data.buttonmaps : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("BUTTON_MAPS")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group mb-0" style={{ float: "right" }}>
                  <div>
                    <button
                      type="reset"
                      className="btn btn-secondary waves-effect  mr-1"
                      onClick={(e) => reset(e.target)}
                    >
                      {_.t("RESET")}
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light mr-1"
                    >
                      {_.t("SUBMIT")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ContactPage;
